export enum GovernmentStaffTypes {
    State = 'State',
    Federal = 'Federal',
}

export const GovernmentStaffTypesMap = {
    [GovernmentStaffTypes.State]: 'State',
    [GovernmentStaffTypes.Federal]: 'Federal',
};
